import { useFormik } from 'formik';
import { initialValues } from './formData';
import { validationSchema } from './formData';
import { SingleDynamicField } from '../../../../../shared/types/assistant';
import { useEffect } from 'react';
import {
    ChatAssistant,
    InitialConfiguration,
} from '../../../../../shared/types/chat-assistant';

interface DynamicConversationMemoryForm {
    [key: string]: SingleDynamicField[];
}

export const useDynamicConversationMemory = (chatAssistant: ChatAssistant) => {
    const formikDynamicConversationMemory =
        useFormik<DynamicConversationMemoryForm>({
            initialValues,
            validationSchema,
            onSubmit: console.log,
        });

    useEffect(() => {
        if (chatAssistant) {
            formikDynamicConversationMemory.setValues({
                dynamicConversationMemory:
                    (
                        chatAssistant?.initialConfiguration as InitialConfiguration
                    )?.dynamicConversationMemory ??
                    initialValues.dynamicConversationMemory,
            });
        }
    }, [chatAssistant]);

    return { formikDynamicConversationMemory };
};
